import type { AxiosInstance } from 'axios';

import type { AuthService } from 'types/AuthService';

import type { WizardUseCases } from '@onboarding/composition/types';
import { createOnboardingHttpClient } from '@onboarding/infrastructure/api';
import { createWizardStatusRepository } from '@onboarding/infrastructure/repositories';
import { completeWizardUseCase } from '@onboarding/application/use-cases';

/**
 * Assembles all wizard use cases with their dependencies.
 * Called ONCE during composition initialization.
 */
export const createWizardUseCases = (
  httpClient: AxiosInstance,
  payHttpClient: AxiosInstance,
  adminHttpClient: AxiosInstance,
  authService: AuthService,
): WizardUseCases => {
  const onboardingHttpClient = createOnboardingHttpClient({ httpClient, payHttpClient, adminHttpClient, authService });
  const wizardStatusPort = createWizardStatusRepository({ httpClient: onboardingHttpClient });

  return {
    completeWizard: completeWizardUseCase({ wizardStatusPort }),
  };
};
